import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SelectItem } from 'primeng/api'; import { environment } from 'src/environments/environment';
import { DataView } from 'primeng/dataview'; import { take, map, mergeMap, filter } from 'rxjs/operators';
import { LiveShopService } from 'src/app/services/liveshop.service'; import { GaleriaComponent } from 'src/app/components/galeria/galeria.component';
import { Product } from 'src/app/api/product'; import { of } from 'rxjs'; import { Capacitor } from '@capacitor/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'; import { Share } from '@capacitor/share';
import { Observable, from, defer } from 'rxjs'; import { FeedService, Feed, User, ListFeedsPayload } from 'src/app/services/feed.service';
import { PrimeNGConfig } from 'primeng/api'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { tap, catchError, finalize, switchMap } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Asset, Item } from 'src/app/models/liveshop';
import { FileUpload } from 'primeng/fileupload';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { formatDate } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';
import { UnregisterSwService } from 'src/app/services/unregister-sw/unregister-sw.service';
import {
  InstagramGalleryService,
  FacebookPage, FacebookPageEdge,
  InstagramBusinessAccount, GraphEdgeResponse
} from 'src/app/services/instagram-gallery.service';
// import { ProductService } from 'src/app/demo/service/product.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn
} from '@angular/forms';
interface TransferProgressEvent {
  transferredBytes: number;
  totalBytes?: number;
}
import { MediaUploadService } from 'src/app/services/media-upload.service';

interface Severities {
  [key: string]: string;
}
interface ProgressEvent {
  transferredBytes: number;
  totalBytes: number | null; // Assumindo que pode ser null, baseado no uso de ?? 1
}
interface SlickType {
  label: string;
  value: string;
}
interface AssetsResponse {
  assets: Asset[];   // Define a propriedade 'assets' como um array de 'Asset'
  totalAssets: number; // Define 'totalAssets' como um número
}
@Component({
  selector: 'app-lives',
  templateUrl: './lives.component.html',
  styleUrls: ['./lives.component.scss']
})
export class LivesComponent implements OnInit, OnDestroy {

  products: Product[] = [];
  assets: Asset[] = [];
  sortOptions: SelectItem[] = [];
  sortOrder: number = 0;
  sortField: string = '';
  sourceCities: any[] = [];
  targetCities: any[] = [];
  orderCities: any[] = [];
  rangeDates: Date[] | null = null;
  constructor(
    private sanitizer: DomSanitizer,
    private errorHandler: ErrorHandlerService,
    private feedService: FeedService,
    private gallery: InstagramGalleryService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private liveShopService: LiveShopService,
    private primengConfig: PrimeNGConfig,
    private unregisterSwService: UnregisterSwService,
    public fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private injector: Injector,
    private mediaUploadService: MediaUploadService
  ) {
    console.log('[Capacitor] referenced in LivesComponent');
    this.issueForm = this.fb.group({
      // exemplo: 'name': ['']
    });
  }
  media_folder: string | null = null;
  isLoading: boolean = false;
  isLoadingSkeleton: boolean = true;

  openSidebarWithDelay(): void {
    setTimeout(() => {
      this.openSidebar();
    }, 100); // Delay aumentado para 3 segundos para garantir que outras operações assíncronas sejam concluídas
  }
  totalAssets: number = 0;
  ////////////////////
  sourceOptions: { label: string, value: string }[] = [];
  selectedSources: string[] = [];
  mediaTypeOptions: { label: string; value: string }[] = [];
  selectedMediaTypes: string[] = [];
  getMediaTypeLabel(type: string): string {
    switch (type.toLowerCase()) {
      case 'reels': return 'Reels';
      case 'IMAGE': return 'Imagem';
      case 'imagem': return 'Imagem';
      default: return type;
    }
  }
  usageRightsOptions: { label: string; value: string; }[] = [];
  selectedUsageRights: string[] = [];

  feedOptions: any[] = [];
  selectedFeeds: string[] = [];

  tagOptions: { label: string; value: string }[] = [];
  selectedFilterTags: string[] = [];

  productOptions: { label: string; value: string; thumbnail: string }[] = [];
  selectedFilterProducts: string[] = [];

  globalInstagramAccounts: Map<string, InstagramBusinessAccount[]> = new Map();
  isMobile = false;
  ////////////////////
  ngOnInit() {
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
    //this.displayAguarde = true;
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params['openSidebar'] === 'true') {
        this.openSidebarWithDelay();
      }
    });

    this.isLoadingSkeleton = true;
    this.primengConfig.ripple = true;
    this.primengConfig.setTranslation({
      emptyMessage: 'Nenhum resultado encontrado' // Mensagem global para quando não houver dados
    });
    this.sendUidsToService([], 0);
    // Cache-first com ETag (src/app/core/http-cache).
    const assetsResource = this.liveShopService.getAssetsRevalidated();

    toObservable(assetsResource.data, { injector: this.injector }).pipe(
      filter((res): res is AssetsResponse => res !== null),
      takeUntil(this.destroy$)
    ).subscribe(res => {  // Utilize a nova interface aqui

        this.assets = res.assets || [];  // Agora 'res' tem 'assets' e 'totalAssets'
        this.totalAssets = res.totalAssets;

        this.filteredAssets = [...this.assets];
        this.OriginalAssets = [...this.assets];

        // Pinta a listagem já com os assets antes de rodar os cálculos
        // pesados abaixo — quando o dado vem do cache (síncrono), sem esse
        // corte a thread principal fica ocupada montando os filtros
        // derivados e a troca de rota trava até tudo terminar (sem nem o
        // skeleton aparecendo). O setTimeout(0) devolve o controle pro
        // browser pintar antes de continuar.
        this.isLoadingSkeleton = false;
        this.displayAguarde = false;

        setTimeout(() => {
        //////////////////////////
        // NOVO BLOCO → cria a lista de fontes únicas para o filtro
        this.sourceOptions = this.filteredAssets
          .flatMap(asset => asset.items)
          .map(item => item.source_id?.toLowerCase())
          .filter((value, index, self): value is string => !!value && self.indexOf(value) === index)
          .map(source => {
            let label = '';
            switch (source) {
              case 'ig':
                label = 'Instagram';
                break;
              case 'tt':
                label = 'TikTok';
                break;
              case 'yt':
                label = 'YouTube';
                break;
              case 'up':
                label = 'Uploads';
                break;
              default:
                label = source;
            }
            return { label, value: source };
          });

        this.mediaTypeOptions = this.filteredAssets
          .flatMap(asset => asset.items)
          .map(item => item.media_type?.toLowerCase()) // ← normaliza para lowercase
          .filter((value, index, self): value is string => !!value && self.indexOf(value) === index)
          .map(type => {
            let label = '';
            switch (type) {
              case 'reels':
                label = 'Reels';
                break;
              case 'carousel_album':
                label = 'Carousel';
                break;
              default:
                label = 'Imagem';
            }
            return { label, value: type };
          });

        this.usageRightsOptions = [
          { label: 'Pendente', value: 'pending' },
          { label: 'Aguardando', value: 'waiting' },
          { label: 'Aprovado', value: 'approved' },
          { label: 'Recusado', value: 'rejected' }
        ];

        // FEED UID + FBID únicos
        this.feedOptions = this.filteredAssets
          .flatMap(asset => asset.items)
          .filter((item, index, self) =>
            item.feed_uid &&
            self.findIndex(i => i.feed_uid === item.feed_uid) === index
          )
          .map(item => {
            const isUploads = item.feed_title?.toLowerCase() === 'uploads';
            const source = item.feed_title?.toLowerCase();
            let picture = null;
            let username = item.feed_title || null;
            if (source === 'uploads') {
              picture = '/assets/icons/upload_feed.jpg';
              username = 'Uploads';
            } else if (source === 'instagram') {
              picture = '/assets/icons/instagram.webp';
            } else if (source === 'facebook') {
              picture = '/assets/icons/facebook.webp';
            } else if (source === 'tiktok') {
              picture = '/assets/icons/tiktok.webp';
            } else if (source === 'youtube') {
              picture = '/assets/youtube-color.svg';
            }

            return {
              label: item.feed_uid,
              value: item.feed_uid,
              fbid: item.fbid,
              feed_type: item.feed_type,
              playlist_title: item.playlist_title ,
              type: item.type,
              hashtag_name: item.hashtag_name,
              picture,
              username,
              source
            };
          });

        // Extração dos fbids únicos
        const fbids = Array.from(
          new Set(this.feedOptions.map(opt => opt.fbid).filter(Boolean))
        );

        // feedOptions acima só cobre feeds com pelo menos 1 item (vem de
        // filteredAssets, que são os slicks já criados) — um feed recém
        // criado ou que ficou sem itens (ex.: todos deletados) nunca aparece
        // no filtro "Feed" do dialog de filtros. Busca a lista completa de
        // feeds do store e injeta os que faltam, sem itens associados.
        this.feedService.listFeeds(200, undefined).subscribe({
          next: (feedsPayload) => {
            const existingUids = new Set(this.feedOptions.map(opt => opt.value));
            const missingFeedOptions = feedsPayload.feeds
              .filter(f => !existingUids.has(f.uid))
              .map(f => {
                const source = f.title?.toLowerCase() || null;
                let picture: string | null = null;
                if (source === 'uploads') picture = '/assets/icons/upload_feed.jpg';
                else if (source === 'instagram') picture = '/assets/icons/instagram.webp';
                else if (source === 'tiktok') picture = '/assets/icons/tiktok.webp';
                else if (source === 'youtube') picture = '/assets/youtube-color.svg';

                return {
                  label: f.uid,
                  value: f.uid,
                  fbid: f.account_id,
                  feed_type: f.feed_type,
                  playlist_title: f.playlist_title,
                  type: f.type,
                  hashtag_name: f.hastag_name,
                  picture,
                  username: f.title || null,
                  source
                };
              });

            if (missingFeedOptions.length) {
              // setTimeout: essa resposta chega numa volta HTTP separada, depois do
              // ciclo de change detection inicial. Se o feed que faltava for o
              // ?feed_uid= da URL (import recém-criado, ainda sem itens), essa
              // atribuição dispara o auto-select por feed_uid no slicks-data-view
              // (ngOnChanges em feedOptions), que reatribui filteredAssets — tudo
              // isso depois que o Angular já checou o template nesse ciclo, gerando
              // ExpressionChangedAfterItHasBeenCheckedError. Empurra pro próximo tick.
              setTimeout(() => {
                this.feedOptions = [...this.feedOptions, ...missingFeedOptions];
              });
            }
          },
          error: (error) => this.errorHandler.handle(error, 'Falha ao carregar lista completa de feeds.')
        });

        this.rebuildTagOptions();

        // Produtos únicos associados a algum slick da listagem atual — mesma
        // lógica de tagOptions (opções vêm dos dados já carregados, não de um
        // catálogo à parte), dedup por sku.
        this.productOptions = Array.from(
          new Map(
            this.filteredAssets
              .flatMap(asset => asset.items)
              .flatMap(item => item.content?.cta?.components?.products?.items ?? [])
              .map((p: any) => [String(p.sku), p])
          ).values()
        ).map((p: any) => ({ label: p.name, value: String(p.sku), thumbnail: p.thumbnail || p.image || '' }));

        /////////////////////////////

        // Calcula a somatória inicial dos durations
        let totalDurationSeconds = this.assets.reduce((acc, asset) => {
          const assetDuration = asset.items.reduce((accInner, item) => {
            return accInner + (item.media.duration || 0); // Adiciona duration, considerando 0 para null
          }, 0);
          return acc + assetDuration;
        }, 0);

        /// filtrar somente itens do feed
        this.route.queryParams.pipe(take(1)).subscribe(params => {
          const feedUidParam = params['feed_uid'];

          if (feedUidParam) {
            // Aplica o filtro apenas se tiver o feed_uid na URL
            this.filteredAssets = this.assets.map(asset => {
              const filteredItems = asset.items.filter(item => item.feed_uid === feedUidParam);
              return { ...asset, items: filteredItems };
            }).filter(asset => asset.items.length > 0); // Remove grupos que ficaram vazios

            // Aviso de que mais itens podem aparecer em instantes — só logo
            // após criar o feed pela busca manual (feed.component.ts marca
            // via router state, nunca via query param, pra não reaparecer
            // num refresh da página). O restante além do lote síncrono
            // inicial é processado em background pela fila (SSAPI-45/47/49),
            // então a listagem pode crescer sozinha nos minutos seguintes.
            if (history.state?.justCreatedFeed) {
              history.replaceState({ ...history.state, justCreatedFeed: false }, '');
              this.confirmationService.confirm({
                key: 'feedCreatedNotice',
                message: 'De acordo com a busca realizada, novos itens podem aparecer nesta listagem em instantes.',
                header: 'Feed criado',
                icon: 'pi pi-info-circle',
                rejectVisible: false,
                acceptLabel: 'Entendi',
                accept: () => {}
              });
            }
          }
        });


        /// filtrar somente itens do feed
        }, 0);
    });

    toObservable(assetsResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null),
      takeUntil(this.destroy$)
    ).subscribe(error => {
        this.displayAguarde = false;
        this.isLoadingSkeleton = false;
        this.errorHandler.handle(error, 'Falha ao extrair o post do Instagram.');
    });

    // Cache-first com ETag.
    const settingsResource = this.liveShopService.detailSettingsRevalidated();

    toObservable(settingsResource.data, { injector: this.injector }).pipe(
      filter((settings): settings is any => settings !== null),
      takeUntil(this.destroy$)
    ).subscribe(settings => {

        // listagem de settings media_folder

        const mediaFolderSetting = settings.find((s: any) => s.key === 'media_folder');
        if (mediaFolderSetting) {
          this.media_folder = mediaFolderSetting.value;
        }

    });

    toObservable(settingsResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null),
      takeUntil(this.destroy$)
    ).subscribe(error => {
        this.displayAguarde = false;
        this.errorHandler.handle(error);
    });





    this.itemsButtons = [
      { label: 'Exportar relatório', icon: 'pi pi-eye' },
    ];

    this.landscapeOptions = [
      { icon: 'pi pi-mobile', name: 'Vertical', value: 1 },
      { icon: 'pi pi-mobile rotate-90', name: 'Horizontal', value: 2 },
    ];
    this.valSelect1Video = this.landscapeOptions[0];
  }

  onSourceSelect() {
    this.applyFilters();
  }
  onMediaTypeChange() {
    this.applyFilters();
  }
  onUsageRightsChange() {
    this.applyFilters();
  }
  onFeedSelect() {
    this.applyFilters();
  }
  onTagsSelect() {
    this.applyFilters();
  }
  onProductsSelect() {
    this.applyFilters();
  }
  valSelect1Video?: any;
  changeLandscape() {

  }
  onSortChange(event: any) {
    const value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }

  onFilter(dv: DataView, event: Event) {
    dv.filter((event.target as HTMLInputElement).value);
  }

  loading: boolean = true;
  filterValue: string = ''; // Armazena o valor do filtro atual
  filteredAssets!: Asset[];
  OriginalAssets!: Asset[];
  selectedType: string | null = null;
  typeOptions = [
    // { label: 'Todos', value: null },
    // { label: 'Live', value: 'live' },
    { label: 'Shorts', value: 'shorts' }
  ];
  selectedStatus: string = 'Status do Slick';

  selectedStreamStatus: string | null = null; // Armazena o status do stream selecionado


  onStreamStatusSelect() {
    this.applyFilters();
  }
  onStatusSelect() {
    const isValidRange =
      Array.isArray(this.rangeDates) &&
      this.rangeDates[0] instanceof Date &&
      this.rangeDates[1] instanceof Date;

    // Com range de data ativo, o fluxo original (fetchFilteredData + filtro
    // local em cima do resultado já reduzido pela data) continua intacto -
    // só o caso "status sozinho, sem data" muda pra ir no backend.
    if (isValidRange) {
      this.applyFilters();
      return;
    }

    if (this.selectedStatus === 'publicado' || this.selectedStatus === 'agendado' || this.selectedStatus === 'naoPublicado') {
      this.fetchStatusFilteredData(this.selectedStatus);
    } else {
      // Voltou pro "Status do Slick" (sem filtro) - restaura o conjunto
      // original carregado no ngOnInit antes de reaplicar os outros filtros.
      this.assets = [...this.OriginalAssets];
      this.applyFilters();
    }
  }

  // Filtro de "Status do Slick" aplicado no backend (ver
  // LiveShopController::listAssets, parâmetro `status`) - a listagem padrão
  // tem limit=500 e filtrar localmente só enxerga o que já carregou, então
  // uma loja com muitos slicks não-publicados fazia o filtro "Publicado" não
  // achar nada mesmo havendo itens de verdade fora dos primeiros 500.
  fetchStatusFilteredData(status: string): void {
    const statusFilteredResource = this.liveShopService.getAssetsByStatusRevalidated(status);

    toObservable(statusFilteredResource.data, { injector: this.injector }).pipe(
      filter((res): res is { assets: Asset[]; totalAssets: number } => res !== null),
      takeUntil(this.destroy$)
    ).subscribe(res => {
      this.assets = res.assets || [];
      this.filterDataLocally();
    });

    toObservable(statusFilteredResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null),
      takeUntil(this.destroy$)
    ).subscribe(err => {
      console.error('Erro ao buscar slicks filtrados por status', err);
    });
  }
  onFilterSlicks(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.applyFilters(); // Atualiza os filtros.
  }

  onDateSelect() {
    const startDate = this.rangeDates && this.rangeDates[0] ? this.rangeDates[0].getTime() : null;
    const endDate = this.rangeDates && this.rangeDates[1] ? this.rangeDates[1].getTime() : null;

    if (startDate && endDate && this.rangeDates && this.rangeDates[0] && this.rangeDates[1]) {
      this.applyFilters();
    }
  }
  onTypeSelect() {
    this.applyFilters();
  }
  date_from!: string | null;
  date_to!: string | null;


  applyFilters() {
    const isValidRange =
      Array.isArray(this.rangeDates) &&
      this.rangeDates[0] instanceof Date &&
      this.rangeDates[1] instanceof Date;

    if (isValidRange) {
      const [start, end] = this.rangeDates!;
      const startDate = start.getTime();
      const endDate = end.getTime();

      this.date_from = this.formatDateToDDMMYYYY(start);
      this.date_to = this.formatDateToDDMMYYYY(end);

      this.fetchFilteredData(startDate, endDate);
      this.sendUidsToService([], 0);
    } else {
      console.log('chamou 1')
      this.filterDataLocally();
    }
  }




  formatDateToDDMMYYYY(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  fetchFilteredData(startDateTimestamp: number, endDateTimestamp: number) {
    const startDate = new Date(startDateTimestamp);
    const endDate = new Date(endDateTimestamp);

    const formattedStartDate = this.formatDateToDDMMYYYY(startDate);
    const formattedEndDate = this.formatDateToDDMMYYYY(endDate);

    // Cache-first com ETag.
    const filteredAssetsResource = this.liveShopService.getFilteredAssetsByDateRevalidated(formattedStartDate, formattedEndDate);

    toObservable(filteredAssetsResource.data, { injector: this.injector }).pipe(
      filter((res): res is { assets: Asset[]; totalAssets: number } => res !== null),
      takeUntil(this.destroy$)
    ).subscribe(res => {
          this.assets = res.assets || [];
          this.filteredAssets = [...this.assets];
          this.totalAssets = res.totalAssets || 0;
          this.reapplyLocalFilters();
    });

    toObservable(filteredAssetsResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null),
      takeUntil(this.destroy$)
    ).subscribe(err => {
          console.error('Erro ao buscar dados filtrados', err);
    });
  }



  reapplyLocalFilters() {
    let totalDuration = 0; // Reseta totalDuration

    // Filtra novamente os assets com base nos filtros locais
    this.filteredAssets = this.filteredAssets.filter(asset => {
      return asset.items.filter(item => {
        // Aplica filtragem por tipo
        const type = item.media.type;
        const typeFilter =
          this.selectedType === 'live' ? (type === null || type.toLowerCase().includes('live')) :
            this.selectedType === 'shorts' ? (type !== null && type.toLowerCase() === 'shorts') : true;

        // Aplica filtragem por status do stream
        const streamStatus = item.media.stream_status;
        const streamStatusFilter =
          this.selectedStreamStatus === 'idle' ? streamStatus?.toLowerCase() === 'idle' :
            this.selectedStreamStatus === 'disabled' ? (streamStatus?.toLowerCase() === 'disabled' || streamStatus === null) :
              this.selectedStreamStatus === 'active' ? streamStatus?.toLowerCase() === 'active' : true;

        // Aplica filtragem por status de publicação
        const now = new Date();
        let dateFrom = item.schedule?.date_from ? new Date(item.schedule?.date_from) : null;
        const statusFilter =
          this.selectedStatus === 'publicado' ? item.media.status === 1 :
            this.selectedStatus === 'agendado' ? (item.media.status === 0 && (!dateFrom || dateFrom > now)) :
              this.selectedStatus === 'naoPublicado' ? item.media.status === 0 && (!dateFrom || dateFrom <= now) : true;
        // Aplica filtragem por nome
        //const nameFilter = item.content.title.toLowerCase().includes(this.filterValue);
        const nameFilter = (item.content.title || "").toLowerCase().includes(this.filterValue.toLowerCase());


        // Verifica se o item passa por todos os critérios de filtro
        const isItemFiltered = typeFilter && streamStatusFilter && statusFilter && nameFilter;

        // Acumula a duração apenas para itens que passam pelo filtro
        if (isItemFiltered && item.media.duration) {
          totalDuration += item.media.duration;
        }

        return isItemFiltered;
      }).length > 0; // Garante que o asset seja incluído se algum item passar pelo filtro
    });

    // Atualiza o tempo total assistido formatado após filtragem
    this.contentTime = this.formatDuration(totalDuration);
  }

  filterDataLocally() {
    let totalDuration = 0;
    const filteredItems: any[] = [];

    const allItems = this.assets.flatMap(asset => asset.items);

    for (const item of allItems) {
      if (this.passaNosFiltros(item)) {
        filteredItems.push(item);

        if (item.media?.duration) {
          totalDuration += item.media.duration;
        }
      }
    }

    this.filteredAssets = [{ items: filteredItems }];
    this.contentTime = this.formatDuration(totalDuration);
    this.collectAndSendUids();
  }






  private passaNosFiltros(item: any): boolean {
    console.log('chamou 2')
    const sourceFilter = this.selectedSources.length === 0 ||
      (item.source_id && this.selectedSources.includes(item.source_id.toLowerCase()));
    const mediaTypeFilter = this.selectedMediaTypes.length === 0 ||
      (item.media_type && this.selectedMediaTypes.includes(item.media_type.toLowerCase()));
    const usageRightsFilter = this.selectedUsageRights.length === 0 ||
      (item.usage_rights && this.selectedUsageRights.includes(item.usage_rights.toLowerCase()));
    const feedFilter = this.selectedFeeds.length === 0 ||
      (item.feed_uid && this.selectedFeeds.includes(item.feed_uid));

    const itemTags = (item.extra?.tags || '').split(',').map((t: string) => t.trim());
    const tagsFilter = this.selectedFilterTags.length === 0 ||
      this.selectedFilterTags.some(tag => itemTags.includes(tag));

    // OR: passa se o slick tiver PELO MENOS UM dos produtos selecionados.
    const itemProductSkus = (item.content?.cta?.components?.products?.items ?? [])
      .map((p: any) => String(p.sku));
    const productsFilter = this.selectedFilterProducts.length === 0 ||
      this.selectedFilterProducts.some(sku => itemProductSkus.includes(sku));



    const type = item.media?.type;
    const typeFilter =
      this.selectedType === 'live' ? (type === null || type?.toLowerCase().includes('live')) :
        this.selectedType === 'shorts' ? (type !== null && type?.toLowerCase() === 'shorts') : true;

    const streamStatus = item.media?.stream_status;
    const streamStatusFilter =
      this.selectedStreamStatus === 'idle' ? streamStatus?.toLowerCase() === 'idle' :
        this.selectedStreamStatus === 'disabled' ? (streamStatus?.toLowerCase() === 'disabled' || streamStatus === null) :
          this.selectedStreamStatus === 'active' ? streamStatus?.toLowerCase() === 'active' : true;

    const now = new Date();
    const dateFrom = item.schedule?.date_from ? new Date(item.schedule.date_from) : null;
    const status = item.media?.status ?? 0;
    const statusFilter =
      this.selectedStatus === 'publicado' ? status === 1 :
        this.selectedStatus === 'agendado' ? (status === 0 && (!dateFrom || dateFrom > now)) :
          this.selectedStatus === 'naoPublicado' ? (status === 0 && (!dateFrom || dateFrom <= now)) :
            true;

    // Nome e usuário
    const storeDataStr = localStorage.getItem('store_data');
    let storeName = '', storeDomain = '';
    if (storeDataStr) {
      try {
        const storeData = JSON.parse(storeDataStr);
        storeName = storeData.store_name?.toLowerCase() || '';
        storeDomain = storeData.store_domain?.toLowerCase() || '';
      } catch (e) {
        console.error('Erro ao parsear store_data:', e);
      }
    }
    const filterLower = this.filterValue.toLowerCase();
    const isUp = item.source_id?.toLowerCase() === 'up';
    const username = isUp ? storeDomain : this.safeLower(item.insights?.insights?.username);
    const name = isUp ? storeName : this.safeLower(item.insights?.insights?.name);
    const title = this.safeLower(item.title) || this.safeLower(item.snippet?.title);
    const description = this.safeLower(item.description) || this.safeLower(item.snippet?.description);
    const caption = this.safeLower(item.caption) || this.safeLower(item.snippet?.caption);

    // MANTÉM todos, juntos!
    const nameFilter =
      username.includes(filterLower) ||
      name.includes(filterLower) ||
      title.includes(filterLower) ||
      description.includes(filterLower) ||
      caption.includes(filterLower);

    return sourceFilter && mediaTypeFilter && usageRightsFilter && feedFilter && tagsFilter &&
      productsFilter && typeFilter && streamStatusFilter && statusFilter && nameFilter;
  }


  safeLower(val: any): string {
    return typeof val === 'string' ? val.toLowerCase() : '';
  }

  // filterDataLocally() {
  //   let totalDuration = 0;
  //   const allItemsFiltered: any[] = [];

  //   const allItems = this.assets.flatMap(asset => asset.items);

  //   const parents = allItems.filter(item => item.parent_id === null);
  //   const children = allItems.filter(item => item.parent_id !== null);

  //   for (const parent of parents) {
  //     const filhosFiltrados = children.filter(child =>
  //       String(child.parent_id) === String(parent.media_id) && this.passaNosFiltros(child)
  //     );

  //     if (this.passaNosFiltros(parent)) {
  //       allItemsFiltered.push(parent);
  //       if (parent.media?.duration) {
  //         totalDuration += parent.media.duration;
  //       }

  //       for (const filho of filhosFiltrados) {
  //         allItemsFiltered.push(filho);
  //         if (filho.media?.duration) {
  //           totalDuration += filho.media.duration;
  //         }
  //       }
  //     } else {
  //       for (const filho of filhosFiltrados) {
  //         allItemsFiltered.push(filho);
  //         if (filho.media?.duration) {
  //           totalDuration += filho.media.duration;
  //         }
  //       }
  //     }
  //   }

  //   // Agrupar filhos órfãos por parent_id
  //   const filhosSemPaiGrouped = new Map<string, any[]>();

  //   for (const child of children) {
  //     if (!child.parent_id) continue;
  //     if (allItemsFiltered.includes(child)) continue;

  //     const pid = String(child.parent_id);
  //     if (!filhosSemPaiGrouped.has(pid)) {
  //       filhosSemPaiGrouped.set(pid, []);
  //     }
  //     filhosSemPaiGrouped.get(pid)?.push(child);
  //   }

  //   for (const [parentId, filhos] of filhosSemPaiGrouped.entries()) {
  //     const filhosFiltrados = filhos.filter(f => this.passaNosFiltros(f));

  //     if (filhosFiltrados.length > 0) {
  //       const fakeParent = {
  //         ...filhosFiltrados[0],
  //         parent_id: null,
  //         isPlaceholderParent: true,
  //         media_id: parentId,
  //         children: { data: filhosFiltrados.slice(1) }
  //       };
  //       allItemsFiltered.push(fakeParent);

  //       for (const f of filhosFiltrados) {
  //         if (f.media?.duration) {
  //           totalDuration += f.media.duration;
  //         }
  //       }
  //     }
  //   }

  //   this.filteredAssets = [{ items: allItemsFiltered }];
  //   this.contentTime = this.formatDuration(totalDuration);
  //   this.collectAndSendUids();
  // }






  calculateTotalDuration() {
    let totalDuration = 0;
    // Lógica para calcular totalDuration...
    this.contentTime = this.formatDuration(totalDuration);
  }

  formatDuration(totalSeconds: number): string {
    // Converte total de segundos para minutos
    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h${minutes.toString().padStart(2, '0')}m`;
  }

  // avg_watched_time (Tempo Assistido) mudou de "% de progresso do vídeo"
  // pra "segundos de engajamento com o player" (par ss_player_started/
  // ss_player_ended, cobre foto e vídeo) — formata como m:ss em vez de %.
  formatWatchedTime(seconds: number): string {
    const total = Math.max(0, Math.round(seconds || 0));
    const minutes = Math.floor(total / 60);
    const secs = total % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  }


  countLikes: number = 0;
  countEspectadores: number = 0;
  timeWatched: number = 0;
  contentTime: string | null = "0h0m";


  countLikes2: number = 0;
  countEspectadores2: number = 0;
  timeWatched2: number = 0;
  contentTime2: string | null = "0h0m";

  percentageLikes: number = 0;
  percentageEspectadores: number = 0;
  percentageWatched: number = 0;
  percentageTime: number = 0;

  collectAndSendUids() {
    const uids = this.filteredAssets.flatMap(asset =>
      asset.items.map(item => item.content.uid)
    );

    // Agora, uids é um array de todos os UIDs dos items filtrados
    this.sendUidsToService(uids, 1);
  }

  formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  sendUidsToService(uids: string[], n: number) {
    this.loading = true;

    if (this.date_from != null && this.date_to != null) {

      // Aqui, formate as datas corretamente
      const formattedDateFrom = this.formatDateToYYYYMMDD(this.convertStringToDate(this.date_from));
      const formattedDateTo = this.formatDateToYYYYMMDD(this.convertStringToDate(this.date_to));

      // SSAPI-84: os cards continuam store-wide por decisão — a página
      // mostra vários slicks filtrados ao mesmo tempo (uids: string[]), não
      // um único slick, então não há slick_id natural pra passar aqui.
      this.liveShopService.getAnalytics(formattedDateFrom, formattedDateTo).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          const overviewData = res.player_analytics.overview_data;

          // Mapeia os campos do novo formato
          this.countLikes = overviewData.likes;
          this.countEspectadores = overviewData.viewers.mobile + overviewData.viewers.desktop;
          this.timeWatched = overviewData.avg_watched_time;
          this.contentTime = this.formatDuration(overviewData.avg_slicks_per_viewer); // ou qualquer campo apropriado
          let contentTimeTmp = overviewData.avg_slicks_per_viewer;

          if (this.date_from != null && this.date_to != null) {
            let dateFrom = this.convertStringToDate(this.date_from);
            let dateTo = this.convertStringToDate(this.date_to);

            // Subtrai 30 dias
            dateFrom.setDate(dateFrom.getDate() - 30);
            dateTo.setDate(dateTo.getDate() - 30);

            let newDateFrom = this.formatDateToYYYYMMDD(dateFrom);
            let newDateTo = this.formatDateToYYYYMMDD(dateTo);

            // Segunda requisição para o período anterior
            this.liveShopService.getAnalytics(newDateFrom, formattedDateFrom).pipe(takeUntil(this.destroy$)).subscribe({
              next: (res) => {
                const previousOverviewData = res.player_analytics.overview_data;

                // Mapeia os campos do novo formato para o período anterior
                this.countLikes2 = previousOverviewData.likes;
                this.countEspectadores2 = previousOverviewData.viewers.mobile + previousOverviewData.viewers.desktop;
                this.timeWatched2 = previousOverviewData.avg_watched_time;
                this.contentTime2 = this.formatDuration(previousOverviewData.avg_slicks_per_viewer);

                // Calcula as porcentagens de diferença
                this.percentageLikes = this.calculatePercentageDifference(this.countLikes, this.countLikes2);
                this.percentageEspectadores = this.calculatePercentageDifference(this.countEspectadores, this.countEspectadores2);
                this.percentageWatched = this.calculatePercentageDifference(this.timeWatched, this.timeWatched2);
                this.percentageTime = this.calculatePercentageDifference(contentTimeTmp, previousOverviewData.avg_slicks_per_viewer);

                this.loading = false;
              },
              error: (error) => {
                this.loading = false;
                this.displayAguarde = false;
                this.errorHandler.handle(error);
              }
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.displayAguarde = false;
          this.errorHandler.handle(error);
        }
      });
    } else {
      // Caso não haja datas, faça uma chamada padrão sem data — cache-first com ETag.
      const noRangeResource = this.liveShopService.getAnalyticsRevalidated('', '');

      toObservable(noRangeResource.data, { injector: this.injector }).pipe(
        filter((res): res is any => res !== null),
        takeUntil(this.destroy$)
      ).subscribe(res => {
          const overviewData = res.player_analytics.overview_data;

          // Mapeia os campos do novo formato
          this.countLikes = overviewData.likes;
          this.countEspectadores = overviewData.viewers.mobile + overviewData.viewers.desktop;
          this.timeWatched = overviewData.avg_watched_time;
          this.contentTime = this.formatDuration(overviewData.avg_slicks_per_viewer);

          this.loading = false;
      });

      toObservable(noRangeResource.error, { injector: this.injector }).pipe(
        filter((error): error is any => error !== null),
        takeUntil(this.destroy$)
      ).subscribe(error => {
          this.loading = false;
          this.displayAguarde = false;
          this.errorHandler.handle(error);
      });
    }
  }


  calculatePercentageDifference(first: number, second: number): number {
    if (first === 0) {
      return second !== 0 ? 100 : 0; // Ajuste conforme a necessidade para casos onde o primeiro valor é 0
    }
    return ((first - second) / first) * 100;
  }
  convertStringToDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(num => parseInt(num, 10));
    return new Date(year, month - 1, day);
  }
  searchTerm: string = '';
  clearFilter() {
    this.rangeDates = null;
    this.selectedStatus = 'Status do Slick';
    this.selectedStreamStatus = null;
    this.selectedType = null;
    this.searchTerm = '';
    this.selectedMediaTypes = [];
    this.selectedSources = [];
    this.selectedUsageRights = [];
    this.selectedFeeds = [];
    this.selectedFilterTags = [];
    this.selectedFilterProducts = [];
    this.sendUidsToService([], 0);

    this.filteredAssets = this.OriginalAssets;
  }

  onSlickDeleted(id: number): void {
    this.assets.forEach((asset: any) => {
      asset.items = asset.items.filter((item: any) => item.content.id !== id);
    });
    this.OriginalAssets.forEach((asset: any) => {
      asset.items = asset.items.filter((item: any) => item.content.id !== id);
    });
  }

  onSlicksDeleted(uids: string[]): void {
    this.assets.forEach((asset: any) => {
      asset.items = asset.items.filter((item: any) => !uids.includes(item.content?.uid));
    });
    this.OriginalAssets.forEach((asset: any) => {
      asset.items = asset.items.filter((item: any) => !uids.includes(item.content?.uid));
    });
    // filteredAssets é um snapshot calculado em applyFilters()/filterDataLocally()
    // — não muda sozinho quando assets/OriginalAssets são mutados acima, por
    // isso o badge "Filtros (N itens)" (filteredItemsCount, que soma os items
    // de filteredAssets) ficava com a contagem antiga mesmo depois do card
    // sumir da grid (que já lê de assets/groupedAssets, mutados corretamente).
    this.applyFilters();
  }

  // slicks-data-view já muta item.media.status nos objetos compartilhados
  // (mesma referência usada aqui em assets/OriginalAssets), então só falta
  // reaplicar o filtro — se "Status do Slick" estiver ativo, os itens que
  // mudaram de status precisam sair/entrar da lista visível agora, e não só
  // trocar de cor no card.
  onSlicksPublishStatusChanged(event: { uids: string[]; status: number }): void {
    this.applyFilters();
  }

  // Opções do filtro "Tags" (tagOptions) só eram calculadas dentro do
  // subscribe de getAssets() (carga inicial) — tags adicionadas depois,
  // individual ou em massa, mutam filteredAssets in place (ver
  // applyLocalTagsMutation em slicks-data-view) mas nunca refletiam nesse
  // filtro até dar reload na página. Extraído em método próprio pra poder
  // ser rechamado por esse handler.
  private rebuildTagOptions(): void {
    this.tagOptions = Array.from(new Set(
      this.filteredAssets
        .flatMap(asset => asset.items)
        .flatMap(item => (item.extra?.tags || '').split(','))
        .map(tag => tag.trim())
        .filter(tag => tag && !tag.startsWith('product_'))
    )).map(tag => ({ label: tag, value: tag }));
  }

  onSlicksTagsChanged(): void {
    this.rebuildTagOptions();
  }

  getActionMenu(id: any, uid: any, title: string) {
    return [
      { label: 'Editar', icon: 'pi pi-file-edit', command: () => this.editSlick(uid) },
      { label: 'Fixar em Link da Bio', icon: 'bi bi-pin-angle-fill', command: () => this.fixarVideo(uid) },
      { label: 'Compartilhar', icon: 'pi pi-share-alt', command: () => this.share(uid) },
      { label: 'Analytics', icon: 'bi bi-graph-up', command: () => this.analytics(uid, title) },
      { label: 'Usar como template', icon: 'bi bi-clipboard', command: () => this.template(uid) },
      { label: 'Deletar', icon: 'pi pi-trash', command: () => this.confirmDeletion(id) },
    ];
  }
  isSharing: boolean = false;
  //Link compartilhado com sucesso!
  async share(uid: string) {
    const domainStore = localStorage.getItem('domain_store') || '';
    const subdomain = domainStore.split('.')[0] || '';
    let shareUrl = `${environment.frontendUrl}/${subdomain}?slick_id=${uid}`;
    // Garante que só adiciona https:// se estiver faltando
    if (!/^https?:\/\//i.test(shareUrl)) {
      shareUrl = 'https://' + shareUrl;
    }

    // Remove qualquer http:// ou https:// do começo
    shareUrl = shareUrl.replace(/^https?:\/\//i, '');

    // Adiciona https:// somente uma vez
    //shareUrl = 'https://' + shareUrl;

    if (Capacitor.isNativePlatform()) {
      // App nativo
      try {
        await Share.share({
          title: 'Compartilhar Link',
          text: 'Veja esse conteúdo!',
          url: shareUrl,
          dialogTitle: 'Compartilhar via'
        });
      } catch (err) {
        console.error('Erro ao compartilhar:', err);
      }
    } else if (navigator.share) {
      // Navegador moderno
      try {
        await navigator.share({
          title: 'Compartilhar Link',
          url: shareUrl
        });
      } catch (err) {
        console.error('Erro ao compartilhar no navegador:', err);
      }
    } else {
      alert('Compartilhamento não suportado neste dispositivo.');
    }
  }


  analytics(uid: string, title: string) {
    this.router.navigate(['/'], { queryParams: { slick_id: uid, title: title } });
  }
  displayAguarde: boolean = false;
  // Múltiplos slicks podem ficar fixados ao mesmo tempo — o dialog de
  // confirmação vira "Fixar"/"Desafixar" dependendo do estado atual do item
  // clicado, guardado aqui no momento do clique.
  pendingUidIsPinned: boolean = false;
  fixarVideo(uid: string) {
    this.pendingUid = uid;
    this.pendingUidIsPinned = this.isUidPinned(uid);
    this.displayConfirmDialog = true;
  }
  private isUidPinned(uid: string): boolean {
    for (const asset of this.assets) {
      const found = asset.items.find((item: any) => item.content.uid === uid);
      if (found) return !!found.media?.pin;
    }
    return false;
  }
  confirmFixarVideo() {
    this.displayAguarde = true;
    this.displayConfirmDialog = false;
    const novoEstado = !this.pendingUidIsPinned;
    this.issueForm = this.fb.group({
      pinned: novoEstado,
    });

    this.liveShopService.pinarSlick(this.issueForm.value, this.pendingUid).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.displayAguarde = false;
        this.messageService.add({
          severity: 'success',
          summary: novoEstado ? 'Slick fixado' : 'Slick desafixado',
          detail: novoEstado ? 'O Slick foi fixado com sucesso!' : 'O Slick foi desafixado com sucesso!'
        });

        // Atualiza só o item alvo — os demais mantêm seu próprio estado de pin.
        let targetItem: any = null;
        this.assets.forEach(asset => {
          asset.items.forEach((item: any) => {
            if (item.content.uid === this.pendingUid) {
              item.media.pin = novoEstado ? 1 : 0;
              targetItem = item;
            }
          });
        });

        // Reordena localmente (pin primeiro, created_at desc dentro de cada
        // grupo) pra não precisar recarregar a página pra refletir a mudança.
        if (targetItem) {
          this.assets.forEach(asset => {
            asset.items = asset.items.filter((item: any) => item.content.uid !== this.pendingUid);
          });
          const items0 = this.assets[0].items;
          const insertIndex = items0.findIndex((item: any) => !item.media?.pin);
          if (insertIndex === -1) {
            items0.push(targetItem);
          } else {
            items0.splice(insertIndex, 0, targetItem);
          }
        }

        // Atualize os assets filtrados
        this.filteredAssets = [...this.assets];

      },
      error: (error) => {
        this.displayAguarde = false;
        let message = '';
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else if (error.status !== 404) {
          message = error.error.message;
        }

        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }

  private pendingUid: string = '';
  displayConfirmDialog: boolean = false;
  // Método para abrir o diálogo de confirmação

  uidSeletedTemplate: string = '';
  template(uid: string) {
    this.uidSeletedTemplate = uid;
    this.displayDialogTemplate = !this.displayDialogTemplate;
  }
  editSlick(uid: string) {
    this.redirectToSlickDetail(uid);
  }
  redirectToSlickDetail(uuid: string): void {
    this.router.navigate(['/slick', uuid]);
  }
  confirmDeletion(n: number) {

    this.confirmationService.confirm({
      message: 'Você realmente deseja remover este slick?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayAguarde = true;
        this.deletarSlick(n);
      },
      reject: () => {
      }
    });
  }
  // deletarSlick(n: number) {

  // }
  displayDialog: boolean = false;
  deletarSlick(n: number): void {
    this.displayDialog = true;
    this.liveShopService.DeleteSlick(n).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.filteredAssets.forEach((asset, index) => {
          this.filteredAssets[index].items = asset.items.filter(item => item.content.id !== n);
        });

        //this.filteredAssets = this.filteredAssets.filter(asset => asset.items.length > 0);

        // Atualize outras listas, se necessário
        this.assets = [...this.filteredAssets];
        this.OriginalAssets = [...this.filteredAssets];


        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Slick Deletado',
          detail: 'O slick foi deletado com sucesso!'
        });
        this.displayAguarde = false;
        this.displayDialog = false;

      },
      error: (error) => {
        this.displayAguarde = false;
        this.errorHandler.handle(error, 'Erro ao deletar slick.');
        this.displayDialog = false;
      }
    });
  }

  getSeverity(label: number): string {
    const severities: Severities = {
      'Enviado': 'success',
      'Parcialmente Enviado': 'warning',
      'Não Enviado': 'info',
      'Pronto p/ Retirada': 'primary',
      'Devolvido': 'danger',
    };
    return severities[label] || 'info';
  }
  getSeverityType(type: string | null): string {
    if (type === 'shorts' || type === 'live' || type === null) {
      return 'custom-white'; // Retornamos um identificador personalizado para a cor branca
    } else {
      return ''; // Retorna um valor padrão caso não se encaixe nas condições (ajustável conforme necessário)
    }
  }

  statusOptions = [
    { label: 'Todos', value: 'todos' },
    { label: 'Publicado', value: 'publicado' },
    { label: 'Não Publicado', value: 'naoPublicado' },
    { label: 'Agendado', value: 'agendado' }
  ];
  getSeverityStatusDropdown(status: any): string {
    switch (status) {
      case 'publicado':
        return 'success';
      case 'naoPublicado':
        return 'warning';
      case 'agendado':
        return 'danger';
      default:
        return '';
    }
  }
  formatDurationPill(duration: number | null, stream_status: string | null, type: string): string {
    if (duration === null || duration == 0 || type === 'live') {

      if (stream_status === null) {
        return 'Ativo';
      }

      if (stream_status !== null || duration == 0 || type === 'live') {

        if (stream_status == 'idle') {
          return 'Ativo';
        }
        if (stream_status == 'disabled') {
          return 'Desativado';
        }
        if (stream_status == 'active') {
          return 'Ao vivo';
        }
        if (stream_status == '') {
          return 'Ativo';
        }

      }

    }

    // Se duration é null e não temos um stream_status válido, retorna "-"
    if (duration === null) {
      return "-";
    }

    if (type !== 'live') {
      let hours = Math.floor(duration / 3600);
      let minutes = Math.floor((duration % 3600) / 60);

      if (hours == 0 && minutes == 0) {
        minutes = 1;
      }
      return `${hours.toString().padStart(2, '0')}h${minutes.toString().padStart(2, '0')}m`;
    }
    if (stream_status == 'idle') {
      return 'Ativo';
    }
    if (stream_status == 'disabled') {
      return 'Desativado';
    }
    if (stream_status == 'active') {
      return 'Ao vivo';
    }
    return "-";
  }
  streamStatusOptions = [
    { label: 'Todos', value: null },
    { label: 'Ativo', value: 'idle' },
    { label: 'Desabilitado', value: 'disabled' },
    { label: 'Ao vivo', value: 'active' }
  ];
  getSeverityStreamStatusDropdown(status: any): string { // active desabilitado
    switch (status) {
      case 'publicado':
        return 'success';
      case 'naoPublicado':
        return 'warning';
      case 'agendado':
        return 'danger';
      default:
        return '';
    }
  }
  // Exemplo de função getSeverityStatus statusOptions
  getSeverityStatus(status: number, dateFromString?: string): string {
    const now = new Date(); // modificação
    let dateFrom = dateFromString ? new Date(dateFromString) : null;

    // Ajustar para a mesma zona horária, se necessário
    // Por exemplo, converter dateFrom para a zona horária local, se estiver em UTC
    // Isso depende de como você quer lidar com as zonas horárias

    if (status === 1) {
      return 'success';
    } else if (status === 0 && (!dateFrom || dateFrom > now)) {
      return 'danger';
    } else if (status === 0) {
      return 'warning';
    } else {
      return ''; // Retorna um valor padrão caso não se encaixe nas condições
    }
  }

  // Função para converter status numérico para texto
  getStatusText(status: number, dateFrom?: Date): string {
    const now = new Date();

    if (status === 1) {
      return 'Publicado';
    } else if (status === 0 && dateFrom && new Date(dateFrom) > now) {
      return 'Agendado';
    } else if (status === 0) {
      return 'Não Publicado';
    } else {
      return 'Desconhecido'; // ou qualquer valor padrão adequado
    }
  }



  getIconDuration(duration: number | null, stream_status: string | null): string {
    if (duration === null) {

      if (stream_status === null) {
        return '';
      }

      if (stream_status !== null) {

        if (stream_status == 'idle') {
          return '';
        }
        if (stream_status == 'disabled') {
          return '';
        }
        if (stream_status == 'active') {
          return 'pi pi-circle-fill custom-color';
        }

      }

    }

    // Se duration é null e não temos um stream_status válido, retorna "-"

    return 'pi pi-play';
  }
  getIconType(type: string | null): string {
    if (!type) {
      return ''; // Retorna o ícone padrão se type for null
    }

    // Normaliza o tipo para minúsculas para simplificar a comparação
    const normalizedType = type.toLowerCase();

    switch (normalizedType) {
      case 'live':
        return 'pi pi-video'; // Retorna o ícone para live
      case 'shorts':
        return 'pi pi-fw pi-chevron-circle-right'; // Retorna o ícone para shorts
      default:
        return ''; // Retorna um ícone padrão se nenhum caso corresponder
    }
  }


  timeoutId: any = null;
  shouldPlay = false;

  startVideo(videoElement: HTMLVideoElement) {
    this.shouldPlay = true;
    // Limpa um timeout existente se houver
    clearTimeout(this.timeoutId);

    // Define um novo timeout para tocar o vídeo
    this.timeoutId = setTimeout(() => {
      this.playVideo(videoElement);
    }, 100);  // atraso de 100ms
  }

  resetVideo(videoElement: HTMLVideoElement) {
    this.shouldPlay = false;
    clearTimeout(this.timeoutId); // Cancela o timeout de play se ainda estiver pendente
    videoElement.pause();
    videoElement.currentTime = 0;
    videoElement.load();
  }

  playVideo(videoElement: HTMLVideoElement) {
    if (this.shouldPlay) {
      videoElement.play().catch(e => {
        console.error("Erro ao tentar reproduzir o vídeo:", e);
      });
    }
  }

  private _displaySidebar: boolean = false;
  get displaySidebar(): boolean {
    return this._displaySidebar;
  }
  set displaySidebar(value: boolean) {
    this._displaySidebar = value;
    // A máscara do p-sidebar (sempre anexada em document.body pelo PrimeNG,
    // fora do :host — não dá pra travar o z-index dela via CSS escopado no
    // componente) usa um z-index calculado em runtime que compartilha um
    // contador global com TODOS os overlays da SPA (ZIndexUtils). Depois de
    // navegar por outro componente com vários dropdowns/dialogs (ex:
    // edit-widget), esse contador pode ficar acima do z-index fixo (41105)
    // que damos ao container dessa sidebar, fazendo a máscara nascer acima
    // dela. Essa classe no body (setter cobre toda atribuição, não só
    // onShow/onHide, porque setar [(visible)] direto não dispara onHide do
    // PrimeNG) força a máscara pro lugar certo — ver regra em styles.scss.
    document.body.classList.toggle('ss-slicks-sidebar-open', value);
  }
  openSidebar() {
    this.displaySidebar = true;
    this.cdr.detectChanges();
    this.valSelect1Video = this.landscapeOptions[0];
  }
  itemsButtons: MenuItem[] = [];
  slickDesc?: string = '';
  slickDescCopy?: string = '';



  // slick type
  slickTypes = [
    { label: 'Shorts', value: 'shorts' },
    // { label: 'Live', value: 'live' }
  ];


  onSelectSlick(event: any) {
  }

  mediaModeOptions = [
    {
      label: 'Upload',
      value: 'upload',
      icon: 'bi bi-upload font-bold'
    },
    {
      label: 'Redes',
      value: 'social'
    }
  ];
  @ViewChild(GaleriaComponent) galeria!: GaleriaComponent;
  @ViewChild('galeriaRef') galeriaRef!: GaleriaComponent;


  closeGaleria() {
    this.showGaleriaSidebar = false;
    this.displaySidebar = true;
  }
  showGaleriaSidebar: boolean = false;
  showContent: boolean = true;
  showAutoPublish: boolean = false;


  feedSource: any;
  openGaleria(source: any) {
    this.feedSource = source;
    this.cdr.detectChanges();


    this.showGaleriaSidebar = true;
    this.displaySidebar = false;
  }
  hashTagJson: any[] = [];
  tagsJson: any[] = [];
  mediaJson: any[] = [];
  storiesJson: any[] = [];
  onHashTagJson(data: any[]) {
    this.hashTagJson = data;
  }
  onStoriesJson(data: any[]) {
    this.storiesJson = data;
    // chamar EP de criar slicks em massa

  }
  onTagsJson(data: any[]) {
    this.tagsJson = data;
    // chamar EP de criar slicks em massa
  }

  onMediaJson(data: any[]) {
    this.mediaJson = data;
    // chamar EP de criar slicks em massa
  }
  mediaMode: string = 'upload';

  // slick type
  showDeleteButton: boolean = false;
  typeLive: boolean = false;
  selectedFile: File | null = null;
  handleUpload(file: File): void {
    this.hasSizeError = false;
    this.hasTypeError = false;
    this.hasError3 = false;
    const ext = file.name.split('.').pop()?.toLowerCase();
    const videoTypes = ['mp4', 'mov', 'webm', 'avi', 'wmv', 'mkv', 'flv', 'mpeg', 'mpg', '3gp', 'm4v'];
    const imageTypes = ['jpg', 'jpeg', 'png', 'webp', 'avif'];

    const fakeEvent = { files: [file] };

    if (videoTypes.includes(ext!)) {
      this.onFileSelect(fakeEvent);
    } else if (imageTypes.includes(ext!)) {
      this.onImageSelect(fakeEvent);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Tipo de arquivo não suportado',
        detail: 'Envie apenas arquivos de vídeo ou imagem.'
      });
    }

    this.selectedFile = file;
  }
  onImageSelect(event: any): void {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    if (event.files && event.files.length > 0) {
      this.imageFile = event.files[0]; // Atribuir o arquivo selecionado à variável imageFile

      // Verificar o tamanho do arquivo (máximo 1MB)
      if (this.imageFile && this.imageFile.size > 1048576) {
        this.erroTamanhoImagem = true;
        this.imageFile = null;
        this.imageSelected = false;
        return;
      }


      // Verificar o tipo do arquivo (webp, png, jpg, jpeg)
      const fileType = this.imageFile?.type;
      if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
        this.erroTipoImagem = true;
        this.imageFile = null;
        this.imageSelected = false;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSelected = true;
        this.imagePreviewUrl = e.target.result; // Atribui a URL da imagem para visualização
      };
      if (this.imageFile) {
        reader.readAsDataURL(this.imageFile);
      }

    } else {
      this.imageSelected = false;
      this.imageFile = null; // Resetar imageFile se nenhum arquivo for selecionado
    }
  }
  onFileSelect(event: any): void {
    this.hasError3 = false;
    this.hasSizeVideoError = false;
    this.hasTypeVideoError = false;

    if (event.files && event.files[0]) {
      this.videoFile = event.files[0]; // Atribuir o arquivo selecionado à variável videoFile

      if (this.videoFile) {
        // Verificar o tamanho do arquivo (máximo 400 MB)
        if (this.videoFile.size > 400 * 1024 * 1024) {
          this.hasSizeVideoError = true;
          this.videoPreviewUrl = null;
          this.videoFile = null; // Resetar videoFile se o tamanho exceder o limite
          return;
        }

        // Verificar o tipo do arquivo
        const allowedTypes = ['video/mp4', 'video/quicktime', 'audio/mpeg', 'audio/wav', 'video/webm', 'video/vnd.avi', 'video/x-ms-wmv', 'video/x-matroska', 'video/x-flv', 'video/mpeg', 'video/3gpp', 'video/x-m4v'];
        if (!allowedTypes.includes(this.videoFile.type)) {
          this.hasTypeVideoError = true;
          this.videoPreviewUrl = null;
          this.videoFile = null; // Resetar videoFile se o tipo não for permitido
          return;
        }

        // Criar uma URL de objeto para o vídeo
        this.videoPreviewUrl = URL.createObjectURL(this.videoFile);

        const videoElement = document.createElement('video');
        videoElement.preload = 'metadata';

        videoElement.onloadedmetadata = () => {
          this.duration = videoElement.duration;
        };

        videoElement.onerror = () => {
          console.error('Erro ao carregar o vídeo.');
        };

        videoElement.src = this.videoPreviewUrl;
        videoElement.load();
      }
    } else {
      this.videoPreviewUrl = null;
      this.videoFile = null; // Resetar videoFile se nenhum arquivo for selecionado
    }
  }



  removeVideoAndImage(): void {
    this.removeVideo(new MouseEvent('click'));
    this.removeImage(new MouseEvent('click'));
    this.selectedFile = null;

    // 🧠 Zerar as variáveis reais de upload:
    this.videoFile = null;
    this.imageFile = null;

    // 🧠 Zera também as URLs de preview (caso os métodos internos não limpem corretamente)
    this.videoPreviewUrl = '';
    this.imagePreviewUrl = null;

    // 🧠 Força também o estado visual
    this.imageSelected = false;
    this.showImageDeleteButton = false;
  }
  removeVideo(event: MouseEvent): void {
    event.stopPropagation();
    this.videoPreviewUrl = '';
  }
  removeImage(event: MouseEvent): void {
    event.stopPropagation();
    this.imageSelected = false;
    this.imagePreviewUrl = null;
    this.showImageDeleteButton = false;
  }
  videoPreviewUrl: string | null = null;
  duration: number = 0;
  hasSizeVideoError: boolean = false;
  hasTypeVideoError: boolean = false;






  onFileSelectCover(event: any): void {
    this.hasError3 = false;
    if (event.files && event.files.length > 0) {
      const file = event.files[0];
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
        };
        reader.readAsDataURL(file);
      }
    }
  }

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  myUploadMethod(event: any) {
    const formData: FormData = new FormData();

    // Vou assumir que você quer enviar o primeiro arquivo selecionado
    const file = event.files[0];
    formData.append('mime', file, file.name);

    // O campo 'folder' é fixo e deve ser enviado junto, como você mostrou no Postman
    formData.append('folder', 'thumbnail');


  }

  closeSidebar() {
    this.displaySidebar = false;
  }

  //tags = ['Água', 'Terra', 'Ar']; // Inicialize com as tags desejadas

  tags = [
    { label: 'Novo', value: 'novo' },
    { label: 'Atual', value: 'atual' },
    { label: 'Antigo', value: 'antigo' }
  ];
  selectedTags: string[] = [];
  tagsString: string = '';
  updateTagsString() {
    this.tagsString = this.selectedTags.join(',');
  }
  publicarAgora: boolean = true;
  publicarAgoraCopy: boolean = true;
  armazenarEvento: boolean = false;
  simular() {

  }
  minDate: Date = new Date();
  disabledDates: Date[] = [];

  // Método para remover uma tag
  // onChipRemove(tagToRemove: string) {
  //   this.tags = this.tags.filter(tag => tag !== tagToRemove);
  // }
  hasError2Copy: boolean = false;
  hasError2: boolean = false;
  hasError3: boolean = false;


  uploadProgress: number = 0;
  uploadProgressVideo: number = 0;
  videoFile: File | null = null;
  imageFile: File | null = null;
  issueForm: FormGroup;
  loadingBtn: boolean = false;
  uploadOn: boolean = false;
  mediaThumbnail?: string;
  mediaSrc?: string;


  tmpFileName?: string;
  tmpMediaName?: string;
  // Função para remover o SW e limpar caches
  async removeServiceWorkerAndCaches(): Promise<void> {
    if ('serviceWorker' in navigator) {
      try {
        // Força a atualização do SW (se houver um novo)
        const registrations = await navigator.serviceWorker.getRegistrations();
        // for (const registration of registrations) {
        //   registration.update();
        // }

        // Desregistra o service worker
        for (const registration of registrations) {
          const success = await registration.unregister();
        }

        // Limpa os caches
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }

        // Força o Bypass for network, removendo o controller do SW
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({ action: 'skipWaiting' });
        }

      } catch (error) {
        console.error('Error while unregistering service worker or clearing caches:', error);
      }
    }
  }
  hasError4: boolean = false;
  hasSizeError: boolean = false;
  hasTypeError: boolean = false;
  errorMessage4?: string;
  handleUploadError(errorType: string): void {
    // Limpa arquivos antigos
    this.videoFile = null;
    this.imageFile = null;
    this.videoPreviewUrl = '';
    this.imagePreviewUrl = null;
    this.selectedFile = null;

    // Limpa flags de erro anteriores
    this.hasSizeError = false;
    this.hasTypeError = false;

    // Aplica o erro atual
    if (errorType === 'size') {
      this.hasSizeError = true;
    }
    if (errorType === 'type') {
      this.hasTypeError = true;
    }

    this.hasError3 = true;
  }

  resetErrors(): void {
    this.hasSizeError = false;
    this.hasTypeError = false;
    this.hasError3 = false;
  }
  async uploadSave() { // uploadOn
    this.uploadProgressVideo = 0;
    this.uploadProgress = 0;

    this.hasError3 = false;
    if (this.mediaMode === 'upload' && !this.videoFile && !this.imageFile) {
      this.hasError3 = true;
      return;
    }

    if (this.mediaMode === 'upload') {
      // 🚨 Verificações obrigatórias
      const noFileSelected = !this.videoFile && !this.imageFile;
      const hasValidationErrors = this.hasSizeError || this.hasTypeError;

      if (noFileSelected || hasValidationErrors) {
        return;
      }

      const uploadStatus = {
        video: false,
        image: false,
      };
      this.loadingBtn = true;
      // Upload de vídeo
      if (this.videoFile) {
        try {
          const { url, key } = await this.uploadFile(this.videoFile, 'slick_media', 1);
          this.tmpMediaName = this.extractNameFromKey(key);
          this.mediaSrc = url;
          uploadStatus.video = true;
        } catch (error: any) {
          this.errorHandler.handle(error, 'Erro no upload do vídeo: ' + error.message);
          uploadStatus.video = false;
        }
      } else {
        uploadStatus.video = true;
      }

      // Upload de imagem
      if (this.imageFile) {
        try {
          const { url, key } = await this.uploadFile(this.imageFile, 'slick_media', 2);
          this.tmpFileName = this.extractNameFromKey(key);
          this.mediaThumbnail = url;
          uploadStatus.image = true;
        } catch (error: any) {
          uploadStatus.image = false;
          this.loadingBtn = false;
        }
      } else {
        uploadStatus.image = true;
      }

      // Se os uploads foram feitos com sucesso, prosseguir com save
      if (uploadStatus.video && uploadStatus.image) {
        this.saveSlicks();

      }
    } else if (this.mediaMode === 'social') {
      // Caso "social", montar itens com filhos (CAROUSEL_ALBUM)
      // Impede envio de mais de 100 mídias (pais + filhos)
      const totalItems = this.importedItems.reduce((acc, item) => {
        const childrenCount = item.children?.data?.length || 0;
        return acc + 1 + childrenCount; // 1 pai + filhos
      }, 0);

      if (totalItems > 100) {
        this.hasError4 = true;
        this.errorMessage4 = 'Você pode importar no máximo 100 mídias por vez.';
        this.loadingBtn = false;
        return;
      } else {
        this.hasError4 = false;
        this.errorMessage4 = '';
      }
      this.loadingBtn = true;

      const seen = new Set<string>();
      const uniqueImportedItems = [];

      for (const item of this.importedItems) {
        // Considera permalink como identificador principal
        const key = item.permalink ?? item.media_url ?? item.id;

        if (!seen.has(key)) {
          seen.add(key);
          uniqueImportedItems.push(item);
        }
      }

      const formattedItems = uniqueImportedItems.flatMap(item => {
        if (item.source === 'tiktok') {
          return [{
            media_id: item.id,
            media_type: item.media_type,
            media_url: item.media_url,
            parent_id: item.id,
            source: 'tiktok',
            caption: item.description || item.title || '',
            thumbnail_url: item.thumb_url || null,
            is_carousel: false,
            post_timestamp: item.create_time || null,
            permalink: item.share_url || null,
            insights: {
              like_count: item.insights?.like_count || 0,
              comment_count: item.insights?.comment_count || 0,
              share_count: item.insights?.share_count || 0,
              play_count: item.insights?.play_count || 0,
              insights: {
                username: item.insights?.username || '',
                name: item.insights?.name || '',
                profile_picture: item.insights?.profile_picture || ''
              }
            },
            duration: item.duration || null,
          }];
        } else if (item.source === 'youtube') {
          return [{
            media_id: item.media_id || item.id,
            media_type: item.media_type || 'VIDEO',
            media_url: item.media_url || item.link,
            parent_id: item.parent_id || item.id,
            source: 'youtube',
            caption: item.caption || item.title || '',
            description: item.description || '',
            thumbnail_url: item.thumbnail_url || item.thumb_url || item.thumbnail || null,
            is_carousel: false,
            post_timestamp: item.post_timestamp || item.publishedAt || null,
            permalink: item.media_url || item.link || null, // pode usar o link do vídeo como permalink se desejar
            insights: {
              like_count: item.insights?.like_count ?? item.statistics?.likeCount ?? 0,
              comment_count: item.insights?.comment_count ?? item.statistics?.commentCount ?? 0,
              view_count: item.insights?.view_count ?? item.statistics?.viewCount ?? 0,
              insights: {
                name: item.insights?.insights?.name || item.channel_title || item.channelTitle || '',
                username: item.insights?.insights?.username || item.email || '',
              }
            },
            channel_id: item.channel_id || item.channelId || null,
            channel_title: item.channel_title || item.channelTitle || null,
            duration: item.duration || null,
          }];
        }

        const children = (item.children?.data || []).filter((child: any) => child.media_url !== item.media_url);

        const formattedChildren = children.map((child: any) => ({
          media_id: child.id,
          permalink: item.permalink,
          parent_id: item.id,
          source: 'instagram',
          caption: item.caption,
          media_type: child.media_type,
          media_url: child.media_url,
          is_carousel: true,
          thumbnail_url: child.thumbnail_url || child.media_url || null,
          post_timestamp: item.timestamp,
          duration: child.duration ?? null,
        }));

        const formattedParent = {
          media_id: item.id,
          permalink: item.permalink,
          parent_id: item.id,
          source: 'instagram',
          media_type: item.media_type,
          media_url: item.media_url,
          caption: item.caption,
          thumbnail_url: item.thumbnail_url || item.media_url || null,
          is_carousel: children.length > 0,
          post_timestamp: item.timestamp,
          duration: item.duration ?? null,
          insights: item.insights || null,
          is_own_media: item.is_own_media || false,
        };

        return [formattedParent, ...formattedChildren];
      });

      const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
      const auto_publish = false;
      this.uploadOn = true;
      this.loadingBtn = true;
      this.feedService.createAssetsFeed(storeId, this.feed_uid, {
        auto_publish,
        items: formattedItems,
        tags: this.tagsString
      }).pipe(finalize(() => this.loadingBtn = false))
        .subscribe({
          next: (res: any) => {
            const createdAssets = res.assets || [];
            this.loadingBtn = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Mídias importadas',
              detail: `Publicado: ${res.published_count}, Não publicados: ${res.unpublished_count}`
            });
            this.resetSidebar();
            if (createdAssets.length === 1) {
              const uid = createdAssets[0].items?.[0]?.content?.uid;
              if (uid) {
                this.redirectToSlickDetail(uid);
              }
              this.filteredAssets = [...createdAssets, ...this.filteredAssets];
            } else if (createdAssets.length > 1) {
              // Atualiza a lista visível sem reload
              this.filteredAssets = [...createdAssets, ...this.filteredAssets];
            }

            this.displaySidebar = false;
            this.importedItems = [];
            this.galeriaRef?.clearSelectedItems();
            this.uploadOn = false;
          },
          error: (error: any) => {
            this.errorHandler.handle(error);
          }
        });
    }

    //}
  }
  resetSidebar(): void {
    this.mediaMode = 'upload'; // ou o valor padrão que você usa

    // Limpa arquivos e previews
    this.videoFile = null;
    this.imageFile = null;
    this.videoPreviewUrl = null;
    this.imagePreviewUrl = null;
    this.mediaSrc = '';
    this.mediaThumbnail = '';

    // Limpa descrição e tags
    this.slickDesc = '';
    this.tagsString = '';
    this.selectedTags = [];

    // Limpa progresso de upload
    this.uploadProgressVideo = 0;
    this.uploadProgress = 0;

    // Limpa lista de itens importados (modo social)
    this.importedItems = [];
    this.galeriaRef?.clearSelectedItems?.();

    // Limpa mensagens de erro e botões
    this.hasError3 = false;
    this.hasError4 = false;
    this.errorMessage4 = '';
    this.uploadOn = false;
    this.loadingBtn = false;
  }

  feed_uid: string = '111';
  async uploadFile(file: File, purpose: 'slick_media', bar: number): Promise<{ url: string; key: string }> {
    try {
      const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
      const result = await this.mediaUploadService.uploadForStore(file, storeId, purpose, (progress) => {
        if (bar === 2) {
          this.uploadProgress = progress;
        } else if (bar === 1) {
          this.uploadProgressVideo = progress;
        }
      });

      return result;

    } catch (error) {
      console.error('Erro no upload:', error);
      const detail = this.parseErr(error);
      this.errorHandler.handle(error, detail);
      throw error;  // Lança o erro para ser tratado onde a função for chamada
    }
  }

  private parseErr(err: unknown): string {
    if (err && typeof err === 'object') {
      const anyErr = err as any;
      if (typeof anyErr.message === 'string') return anyErr.message;
      if (typeof anyErr.name === 'string') return anyErr.name;
    }
    try { return JSON.stringify(err); } catch { return 'Ocorreu um erro inesperado.'; }
  }



  checkUploadsAndSave(uploadStatus: any) {
    // Verifica se ambos os uploads (vídeo e imagem) foram concluídos
    if (uploadStatus.video && uploadStatus.image) {
      // Aguarda até que this.uploadProgressVideo atinja 100%
      if (uploadStatus.video) {
        const intervalStartedAt = Date.now();
        const interval = setInterval(() => {
          // Timeout de segurança (30s) — evita loop eterno caso o progresso
          // nunca chegue exatamente a 100 (ex: upload cancelado/travado).
          if (this.uploadProgressVideo === 100 || Date.now() - intervalStartedAt > 30000) {
            clearInterval(interval);
            this.saveSlicks();
            this.loadingBtn = false;
          }
        }, 100);
      } else {
        this.saveSlicks();
        this.loadingBtn = false;
      }

    } else {
      this.saveSlicks();
    }
  }
  generateUID() {
    return uuidv4();
  }

  resetFormCreator() {
    this.slickDesc = undefined;
    this.selectedTags = [];
    this.updateTagsString();
    this.publicarAgora = true;
    this.armazenarEvento = false;
    this.imageSelected = false;
    this.imageFile = null;
    this.videoPreviewUrl = null;
    this.typeLive = false;
    this.videoFile = null;
  }

  replaceDomain(url: string | undefined): string | undefined {
    const s3Domain = 'https://krabo163508-dev.s3.sa-east-1.amazonaws.com';
    const cloudFrontDomain = 'https://d2434dp583bttd.cloudfront.net';
    if (url && url.includes(s3Domain)) {
      return url.replace(s3Domain, cloudFrontDomain);
    }
    return url; // Retorna a URL original, que pode ser undefined
  }



  saveSlicks() {
    this.uploadOn = true;
    this.issueForm = this.fb.group({
      "widget": this.fb.array([
        this.fb.group({
          "assets": this.fb.group({
            "items": this.fb.array([
              this.fb.group({
                "schedule": this.fb.group({
                  "date_from": null,
                  "date_to": null
                }),
                "media": this.fb.group({
                  "type": this.videoFile ? 'shorts' : 'photo',
                  "src": this.replaceDomain(this.mediaSrc),
                  "duration": this.duration,
                  "thumbnail": this.replaceDomain(this.mediaThumbnail),
                  "aspect_ratio": this.valSelect1Video.value,
                  "media_type": this.videoFile ? 'reels' : 'IMAGE',
                }),
                "content": this.fb.group({
                  "title": '',
                  "description": this.slickDesc,
                  "cta": this.fb.group({
                    "type": 0,
                    "style": {
                      "size": {
                        "width": null,
                        "height": null
                      },
                      "padding": {
                        "top": null,
                        "right": null,
                        "bottom": null,
                        "left": null
                      },
                      "colors": {
                        "background": null,
                        "font": null
                      },
                      "position": null
                    },
                    "components": {
                      "custom": {
                        "title": "",
                        "redirect_url": ""
                      },
                      "whatsapp": {
                        "phone": ""
                      },
                      "products": {
                        "items": []
                      }
                    }
                  })
                }),
                extra: this.fb.group({ // Início do FormGroup 'extra'
                  player: this.fb.group({ // FormGroup 'player' dentro de 'extra'
                    time_to_pitch: [0],
                    time_to_pitch_value: [],
                    player_color: [],
                    progress_bar_color: [],
                    auto_play: [0],
                    show_progress_bar: [0],
                  }),
                  "tags": this.tagsString
                }),
                feeds: this.fb.group({
                  source_id: [''],
                  title: [''],
                  type: [''],
                  media_type: [''],
                  account_id: [''],
                  moderation: [null],
                  hashtag_id: [''],
                  hastag_name: [''],
                  hashtag_search: [''],
                  media_id: [''],
                  children_id: [''],
                  is_carousel: [''],
                })
              })
            ])
          })
        })
      ])
    });

    this.liveShopService.saveSlick(this.issueForm.value).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.loadingBtn = false;
        this.uploadOn = false;
        this.resetSidebar();
        if (!this.uploadOn) {
          // zerar form
          this.resetFormCreator();

        }
        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Slick Salvo',
          detail: 'O slick foi salvo com sucesso!'
        });
        this.displayAguarde = false;
        // Routersss
        if (res.widget && res.widget.length > 0 && res.widget[0].assets.items.length > 0 && res.widget[0].assets.items[0].content.uid) {
          this.redirectToSlickDetail(res.widget[0].assets.items[0].content.uid);
        } else {
          // Exiba uma mensagem de erro
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao criar slick.'
          });
        }
      },
      error: (error) => {
        this.displayAguarde = false;
        this.uploadOn = false;
        this.loadingBtn = false;
        if (error.status === 400) {
          this.displayLimitDialog = true;
          this.liveShopService.postToExternalEndpoint(this.media_folder ? this.media_folder : '', this.tmpMediaName ? this.tmpMediaName : '').subscribe({
            next: (res) => {
            },
            error: (error) => {
              console.error('Error posting to external endpoint', error);
            }
          });
        } else {
          this.errorHandler.handle(error, 'Erro ao criar slick.');
        }
        this.displayDialog = false;
        this.displayAguarde = false;
      }
    });
  }
  displayLimitDialog: boolean = false;
  upgradePlan() {
    this.displayLimitDialog = false;
    this.router.navigate(['/upgrade']);
  }
  closeLimitDialog() {
    this.displayLimitDialog = false;
  }
  landscapeOptions: any[] = [];

  // Extrai o nome (sem extensão) do arquivo a partir da key retornada pelo
  // presign (ex: "media/{folder}/{uuid}.mp4" -> "{uuid}").
  private extractNameFromKey(key: string): string {
    const basename = key.split('/').pop() ?? key;
    return basename.replace(/\.[^./]+$/, '');
  }

  uploadProgress$?: Observable<number>;







  imageSelected: boolean = false;
  imagePreviewUrl: string | null = null;
  showImageDeleteButton: boolean = false;
  // Supondo que `hasErrorImage` seja a sua variável para controle de erro de imagem
  hasErrorImage: boolean = false;
  erroTamanhoImagem: boolean = false;
  erroTipoImagem: boolean = false;
  // Método chamado quando um arquivo de imagem é selecionado



  // Método para remover a imagem selecionada


  // Método para o upload da imagem
  myImageUploadMethod(event: any): void {
    // Implemente a lógica para o upload da imagem
  }

  getSeverityFilterTypeLive(value: string): string {
    if (value === 'live') {
      return 'info';
    } else if (value === 'shorts') {
      return 'success';
    } else {
      return 'neutral'; // ou qualquer outro valor padrão de severidade
    }
  }
  handleCanPlayThrough() {
  }
  displayDialogTemplate: boolean = false;
  closeCopyTemplate() {
    this.displayDialogTemplate = false;
  }
  isTemplate: boolean = false;
  createTemplate() {

    this.isTemplate = true;
    this.liveShopService.detailAsset(this.uidSeletedTemplate).pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp) => {
        ////////////////////////
        this.issueForm = this.fb.group({
          "widget": this.fb.array([
            this.fb.group({
              "assets": this.fb.group({
                "items": this.fb.array([
                  this.fb.group({
                    "schedule": this.fb.group({
                      "date_from": null,
                      "date_to": null
                    }),
                    "media": this.fb.group({
                      "type": resp.items[0].media.type,
                      "src": resp.items[0].media.src,
                      "duration": resp.items[0].media.duration,
                      "thumbnail": resp.items[0].media.thumbnail,
                      "media_type": resp.items[0].media.media_type,
                      "aspect_ratio": resp.items[0].media.aspect_ratio
                    }),
                    "content": this.fb.group({
                      "title": '',
                      "description": this.slickDescCopy,
                      "cta": this.fb.group({
                        "type": 0,
                        "style": {
                          "size": {
                            "width": null,
                            "height": null
                          },
                          "padding": {
                            "top": null,
                            "right": null,
                            "bottom": null,
                            "left": null
                          },
                          "colors": {
                            "background": null,
                            "font": null
                          },
                          "position": null
                        },
                        "components": {
                          "custom": {
                            "title": "",
                            "redirect_url": ""
                          },
                          "whatsapp": {
                            "phone": ""
                          },
                          "products": {
                            "items": []
                          }
                        }
                      })
                    }),
                    extra: this.fb.group({ // Início do FormGroup 'extra'
                      player: this.fb.group({ // FormGroup 'player' dentro de 'extra'
                        time_to_pitch: [0],
                        time_to_pitch_value: [],
                        player_color: [],
                        progress_bar_color: [],
                        auto_play: [0],
                        show_progress_bar: [0],
                      }),
                      "tags": resp.items[0].extra.tags
                    })
                  })
                ])
              })
            })
          ])
        });

        this.liveShopService.saveSlick(this.issueForm.value).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res1) => {


            ///////////////////////////////
            this.issueForm = this.fb.group({
              widget: this.fb.array([ // Início do FormArray para 'widget'
                this.fb.group({ // Início do FormGroup dentro do array 'widget'
                  assets: this.fb.group({ // Início do FormGroup para 'assets'
                    items: this.fb.array([ // Início do FormArray para 'items'
                      this.fb.group({ // Início do FormGroup para cada item em 'items'
                        schedule: this.fb.group({
                          date_from: [resp.items[0].schedule.date_from],
                          date_to: [resp.items[0].schedule.date_to]
                        }),
                        media: this.fb.group({
                          type: [resp.items[0].media.type],
                          src: resp.items[0].media.src,
                          time_to_pitch: resp.items[0].media.time_to_pitch,
                          duration: resp.items[0].media.duration,
                          thumbnail: resp.items[0].media.thumbnail,
                          aspect_ratio: resp.items[0].media.aspect_ratio,
                          status: resp.items[0].media.status
                        }),
                        content: this.fb.group({
                          title: '',
                          uuidCopy: [this.uidSeletedTemplate],
                          description: [this.slickDescCopy],
                          cta: this.fb.group({
                            type: [0],
                            components: this.fb.group({
                              custom: this.fb.array(resp.items[0].content.cta.components.custom), // Se 'this.accordionTabs' já é um array, use diretamente sem colchetes adicionais
                              whatsapp: this.fb.array(resp.items[0].content.cta.components.whatsapp), // Se 'this.whatsappTabs' já é um array, use diretamente sem colchetes adicionais
                              products: this.fb.group({
                                items: this.fb.array(resp.items[0].content.cta.components.products.items) // Se 'this.targetProducts' já é um array, use diretamente sem colchetes adicionais
                              }),
                              promotions: this.fb.group({
                                items: this.fb.array(resp.items[0].content.cta.components.promotions.items) // Se 'this.targetPromotions' já é um array, use diretamente sem colchetes adicionais
                              }),
                              alerts: this.fb.array(resp.items[0].content.cta.components.alerts),
                              links: this.fb.array(resp.items[0].content.cta.components.links)
                            })
                          })
                        }),
                        extra: this.fb.group({ // Início do FormGroup 'extra'
                          player: this.fb.group({ // FormGroup 'player' dentro de 'extra'
                            time_to_pitch: [resp.items[0].extra.player.time_to_pitch ? 1 : 0],
                            time_to_pitch_value: resp.items[0].extra.player.time_to_pitch_value,
                            player_color: resp.items[0].extra.player.player_color,
                            progress_bar_color: [resp.items[0].extra.player.progress_bar_color],
                            auto_play: [resp.items[0].extra.player.auto_play ? 1 : 0],
                            show_progress_bar: [resp.items[0].extra.player.show_progress_bar ? 1 : 0],

                          }),
                          "tags": resp.items[0].extra.tags
                        })
                      }) // Fim do FormGroup para cada item em 'items'
                    ]) // Fim do FormArray para 'items'
                  }) // Fim do FormGroup para 'assets'
                }) // Fim do FormGroup dentro do array 'widget'
              ]) // Fim do FormArray para 'widget'
            });
            //////////////////// novo



            this.liveShopService.updateAsset(this.issueForm.value, res1.widget[0].assets.items[0].content.id).pipe(takeUntil(this.destroy$)).subscribe({
              next: (res) => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Slick Salvo',
                  detail: 'O slick foi salvo com sucesso123!'
                });
                this.isTemplate = false;
                this.redirectToSlickDetail(res1.widget[0].assets.items[0].content.uid);

                // Router
              },
              error: (error) => {
                let message = '';
                this.isTemplate = false;
                if (error.status === 400 || error.status === 403 || error.status === 401) {
                  message = error.error.message;
                } else if (error.status === 500) {
                  message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
                } else if (error.status !== 404) {
                  message = error.error.message;
                }

                if (message) {
                  this.showErrorDialog(message);
                }
              }
            });
            ///////////////////////////////
          },
          error: (error) => {
            this.isTemplate = false;
            this.errorHandler.handle(error, 'Erro ao criar slick.');
          }
        });
        ////////////////////////

      }
    });
  }
  showErrorDialog(message: string) {
    this.confirmationService.confirm({
      message: message,
      header: 'Erro',
      icon: 'pi pi-times',
      accept: () => {
        // Lógica de aceitação, se necessário
      }
    });
  }

  resetDialogInputs(): void {
    this.slickDescCopy = '';
    this.publicarAgoraCopy = true;
    this.hasError2Copy = false;
    this.isTemplate = false;
    this.uploadOn = false;
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.classList.remove('ss-slicks-sidebar-open');
  }
  /////////////////////
  importedItems: any[] = [];

  importarSelecionados() {
    const novosItens = this.galeriaRef?.selectedItems || [];

    novosItens.forEach(item => {
      const itemId = item.id;

      const jaExiste = this.importedItems.some(existing => {
        if (existing.id === itemId) return true; // pai duplicado
        if (existing.children?.data?.some((child: any) => child.id === itemId)) return true; // filho duplicado
        return false;
      });

      if (jaExiste) return;

      let convertido: any;

      if (this.feedSource === 'tiktok') {
        // TikTok vem com estrutura diferente
        convertido = {
          id: item.id,
          media_type: 'VIDEO',
          media_url: item.video_url || item.share_url, // ou usar proxy se necessário
          thumb_url: item.cover_image_url,
          title: item.title || '',
          description: item.video_description || '',
          create_time: item.create_time,
          source: 'tiktok',
          embed_html: item.embed_html,
          share_url: item.share_url,
          insights: {
            like_count: item.like_count || 0,
            comment_count: item.comment_count || 0,
            share_count: item.share_count || 0,
            play_count: item.play_count || 0,
            username: item.tiktok_username || '',
            name: item.tiktok_name || '',
            profile_picture: item.tiktok_profile_picture || ''
          },
          duration: item.duration || null,
        };
      } else if (this.feedSource === 'google') {
        // YouTube: monta o objeto compatível
        convertido = {
          media_id: item.id,
          parent_id: item.id, // Sempre o próprio para YouTube
          source: 'youtube',
          thumbnail_url: item.thumbnail || null,
          media_type: 'VIDEO',
          media_url: item.link, // Link para o vídeo no YouTube
          caption: item.title || '',
          description: item.description || '',
          is_carousel: false,
          post_timestamp: item.publishedAt,
          insights: {
            like_count: item.statistics?.likeCount ? Number(item.statistics.likeCount) : 0,
            comment_count: item.statistics?.commentCount ? Number(item.statistics.commentCount) : 0,
            view_count: item.statistics?.viewCount ? Number(item.statistics.viewCount) : 0,
            insights: {
              name: item.channelTitle || '', // nome do canal
              username: item.email || ''     // email do usuário Google
            }
          },
          channel_id: item.channelId || null,
          channel_title: item.channelTitle || null,
          duration: item.duration || null,
          // Você pode adicionar outros campos se quiser
        };
      } else {
        // Instagram já está no formato esperado
        convertido = {
          ...item,
          source: 'instagram'
        };
      }

      this.importedItems.push(convertido);
    });

    this.galeriaRef.selectedItems = [];
    this.showGaleriaSidebar = false;
    this.mediaMode = 'social';
    this.displaySidebar = true;
  }

  removeImportedItem(item: any) {
    this.importedItems = this.importedItems.filter(i => i.id !== item.id);
  }

  clearImportedItems() {
    this.importedItems = [];
    this.galeria.selectedItems = [];
    this.galeria.tiktokVideos = [];
  }

  /////////////////////
  slideToNext(id: string): void {
    const swiper = this.findSwiperByUid(id);
    if (swiper) {
      swiper.slideNext();
    } else {
      console.warn('❌ Swiper não encontrado para UID (next):', id);
    }
  }

  slideToPrev(id: string): void {
    const swiper = this.findSwiperByUid(id);
    if (swiper) {
      swiper.slidePrev();
    } else {
      console.warn('❌ Swiper não encontrado para UID (prev):', id);
    }
  }

  private findSwiperByUid(uid: string): any {
    const elements = Array.from(document.querySelectorAll('[data-uid]'));
    for (const el of elements) {
      if (el.getAttribute('data-uid') === uid && (el as any).swiper) {
        return (el as any).swiper;
      }
    }
    return null;
  }

}

